import {
  useZustandLanguagesKitStore,
  languageSelectors,
  useZustandModalKitStore,
  EModalTypes,
  zustandModalKitSelector,
} from 'react-gldn-kit';
import cln from 'classnames';
import { getFlagIcon } from 'utils/icons';

import styles from './ButtonLanguage.module.css';

const ButtonLanguage = ({ classes }: { classes?: string }) => {
  const activeLanguageName = useZustandLanguagesKitStore(
    languageSelectors.getActiveLanguageNameKitSelector
  );

  const setModal = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const handleOpenPopUp = (e?: React.MouseEvent<HTMLDivElement>) => {
    e?.stopPropagation();
    e?.preventDefault();

    setModal(EModalTypes.Languages, {
      title: 'languages',
    });
  };

  return (
    <div
      className={cln(styles.wrapperButtonLanguage, classes)}
      onClick={handleOpenPopUp}
    >
      {activeLanguageName ? getFlagIcon(activeLanguageName) : 'loading'}
    </div>
  );
};

export default ButtonLanguage;
